module.exports = __webpack_public_path__ + "static/media/spinner.2c0c5093.gif";